import React from 'react';

// Services
import { colorCellPharmacy, getRescueDose } from '../../../services/Pharmacy';

// Interfaces
import { DrugAdministrationList } from '../../../interfaces/Drug';

const CellSumContent: React.FC<{
    date: string,
    drug: DrugAdministrationList,
}> = ({ date, drug }) => {

    const hoursDose = Object.keys(drug.hours);

    const getRescueDosesDate = (date: string) => {
        let rescueDoses = 0;
        hoursDose.map(hour =>
            rescueDoses += getRescueDose(drug.hours[hour][date]));
        if (rescueDoses === 0) return '';
        else return `(+${rescueDoses})`;
    };

    const getTotalMg = (date: string) => {
        let dose = 0;
        let unit = '';
        hoursDose.forEach(hour => {
            if (unit.trim() === '') unit = drug.hours[hour][date] ? drug.hours[hour][date][0].drug_dose_unit || '' : '';
            dose += drug.hours[hour][date] ?
                Number(drug.hours[hour][date][0].drug_dose_amount)
                : 0;
        });
        return dose !== 0 ? dose + ' ' + unit : '';
    };

    const colorCellDropdown = (date: string) => {
        const classes = hoursDose.map(hour =>
            drug.hours[hour][date] ?
                colorCellPharmacy(Boolean(drug.hours[hour][date][0].deleted_at), drug.hours[hour][date][0].status) : '');

        if (classes.some(colorClass => colorClass === 'grayCell')) return 'grayCell';
        else if (classes.some(colorClass => colorClass === 'redCell')) return 'redCell';
        else if (classes.some(colorClass => colorClass === 'yellowCell')) return 'yellowCell';
        else if (classes.some(colorClass => colorClass === 'greenCell')) return 'greenCell';
        else return getTotalMg(date) === '' ? 'grayCell' : '';
    };

    return (
        <td className={`pharmaCell ${colorCellDropdown(date)}`} >
            {getTotalMg(date)} <span style={{ fontWeight: 'bold' }}>{getRescueDosesDate(date)}</span>
        </td>
    );
};

export default CellSumContent;